module.exports = __webpack_public_path__ + "img/__icon_FIRANKA.f1e1ea1f.svg";